import {
  Smartphone,
  Zap,
  Globe,
  Compass,
  Share2,
  MousePointerClick,
  type LucideIcon,
} from 'lucide-react'
import type { Language } from '@/i18n/types'
import { en } from '@/i18n/en'
import { ro } from '@/i18n/ro'

/** `priceKey` names a row of `public_prices` — see src/lib/publicPrice.ts. */
export interface ModalItem {
  label: string
  priceKey?: string
  details?: string[]
}

export interface ModalSection {
  heading: string
  priceKey?: string
  description?: string
  items?: ModalItem[]
}

export interface ModalTier {
  name: string
  priceKey: string
  description?: string
  features: string[]
  highlighted?: boolean
  badge?: string
}

export interface ServiceData {
  id: string
  icon: LucideIcon
  title: string
  cardDescription: string
  highlighted?: boolean
  modal: {
    title: string
    priceKey?: string
    description?: string
    tiers?: ModalTier[]
    sections: ModalSection[]
    addOns?: string[]
    notes?: string[]
  }
}

const iconMap: Record<string, LucideIcon> = {
  'social-media-subscription': Smartphone,
  'automation-ai': Zap,
  'web-digital-platforms': Globe,
  'strategy-brand-identity': Compass,
  'social-media-alacarte': Share2,
  'ppc-advertising': MousePointerClick,
}

const highlightedIds = ['social-media-subscription', 'automation-ai', 'web-digital-platforms']

const serviceIds = [
  'social-media-subscription',
  'automation-ai',
  'web-digital-platforms',
  'strategy-brand-identity',
  'social-media-alacarte',
  'ppc-advertising',
]

const translations = { en, ro }

export function getServices(language: Language): ServiceData[] {
  const t = translations[language]
  return serviceIds.map(id => {
    const data = t.serviceData[id]
    return {
      id,
      icon: iconMap[id],
      title: data.title,
      cardDescription: data.cardDescription,
      highlighted: highlightedIds.includes(id),
      modal: data.modal,
    }
  })
}

// Default export for backwards compatibility
export const services = getServices('en')
